var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout addresses" },
    [
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [
          _vm._v("Корректировка адресов"),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("Button", {
                attrs: {
                  size: "small",
                  icon: {
                    icon: "bookmark",
                    activeColor: "white",
                  },
                  tooltip: {
                    text: "Добавить в закладки",
                    activeText: "Убрать из закладок",
                  },
                  "active-color": "blue",
                  active: _vm.bookmark,
                },
                on: {
                  click: function ($event) {
                    _vm.bookmark = !_vm.bookmark
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("GoogleSheetsAction", {
                ref: "googleForm",
                attrs: { "table-name": "bad_address", disabled: _vm.busy },
              }),
            ],
            1
          ),
          _vm.canEdit
            ? _c(
                "div",
                { staticClass: "layout-header-action" },
                [
                  _c("Button", {
                    attrs: {
                      responsive: true,
                      size: "small",
                      label: "Новый адрес",
                      icon: { icon: "plus", color: "primary" },
                    },
                    on: { click: _vm.createAddress },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      !_vm.isInitialized
        ? _c("Loader", {
            attrs: { label: "Данные загружаются", height: 300, active: true },
          })
        : [
            _c(
              "form",
              {
                staticClass: "global-filters",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.applySearchParams.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "global-filters__period" },
                  [
                    _c("Select", {
                      attrs: {
                        label: "Период действия",
                        placeholder: "Любой",
                        items: _vm.periodList,
                        clearable: true,
                      },
                      model: {
                        value: _vm.globalFilters.badAddressPeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.globalFilters, "badAddressPeriod", $$v)
                        },
                        expression: "globalFilters.badAddressPeriod",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "global-filters__name" },
                  [
                    _c("Input", {
                      attrs: {
                        placeholder: "Поиск",
                        icon: "search",
                        clearable: true,
                      },
                      model: {
                        value: _vm.globalFilters.search,
                        callback: function ($$v) {
                          _vm.$set(_vm.globalFilters, "search", $$v)
                        },
                        expression: "globalFilters.search",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "global-filters__actions" },
                  [
                    _c("Button", {
                      attrs: { label: "Сбросить" },
                      on: { click: _vm.resetGlobalFilters },
                    }),
                    _c("Button", {
                      attrs: {
                        label: "Применить",
                        color: "primary",
                        type: "submit",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "table-settings" },
              [
                _c("Button", {
                  attrs: {
                    label: "Сбросить фильтры столбцов",
                    icon: { color: "secondary", icon: "filter-drop" },
                    type: "with-icon",
                    size: "small",
                    disabled: !_vm.hasColumnFilters,
                    responsive: true,
                  },
                  on: { click: _vm.resetColumnFilters },
                }),
                _c("Button", {
                  attrs: {
                    label: "Настроить столбцы",
                    size: "small",
                    icon: "cog",
                    type: "with-icon",
                    responsive: true,
                  },
                  on: { click: _vm.configureColumns },
                }),
              ],
              1
            ),
            _c("Table", {
              ref: "table",
              class: {
                "hide-when-sm": !_vm.entries.length,
              },
              attrs: {
                filters: _vm.columnFilters,
                columns: _vm.cleanColumns,
                lists: _vm.lists,
                entries: _vm.entries,
                "sort-by": _vm.sort.by,
                "sort-dir": _vm.sort.dir,
                "can-edit": _vm.canEdit,
              },
              on: {
                "update:sortBy": function ($event) {
                  return _vm.$set(_vm.sort, "by", $event)
                },
                "update:sort-by": function ($event) {
                  return _vm.$set(_vm.sort, "by", $event)
                },
                "update:sortDir": function ($event) {
                  return _vm.$set(_vm.sort, "dir", $event)
                },
                "update:sort-dir": function ($event) {
                  return _vm.$set(_vm.sort, "dir", $event)
                },
                filter: _vm.setColumnFilter,
                nextPage: _vm.fetchNextPage,
                edit: _vm.updateAddress,
                remove: _vm.removeAddress,
              },
            }),
            _vm.busy
              ? _c("Loader", {
                  staticClass: "loader",
                  attrs: {
                    label: "Данные загружаются",
                    height: 300,
                    active: true,
                  },
                })
              : _vm._e(),
            !_vm.entries.length
              ? _c("div", { staticClass: "empty" }, [
                  _vm._v(" " + _vm._s(_vm.emptyResultText) + " "),
                ])
              : _vm._e(),
          ],
      _c("TopButton", { attrs: { root: ".layout" } }),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isInitialized && !_vm.busy && _vm.totalCount > 0
            ? _c("ItemsCount", {
                attrs: {
                  "shown-items-count": _vm.entries.length,
                  "total-items-count": _vm.totalCount,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("ColumnsModal", {
        ref: "columnsModal",
        attrs: { columns: _vm.columns },
        on: { apply: _vm.saveUserColumns },
      }),
      _c("Sidesheet", {
        ref: "addressSidesheet",
        attrs: { "can-edit": _vm.canEdit },
        on: {
          create: _vm.onAddressCreate,
          update: _vm.onAddressUpdate,
          remove: (id) => _vm.removeAddress({ id }),
        },
      }),
      _c("RemoveModal", {
        ref: "removeAddressModal",
        on: { remove: _vm.onAddressRemove },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }